module.exports = __webpack_public_path__ + "static/media/page3small.807e2531.png";